<template>
  <ion-page>
    <ion-content color="primary">
      <div class="d-flex h-100 justify-space-between flex-column align-center personalize-wrapper">
        <div>
          <ion-img v-if="arriboLogo" :src="arriboLogo" alt="Arribo Logo"></ion-img>
        </div>
        <div class="content d-flex w-100 px-xs py-lg justify-space-center">
          <SignUpStepperAbroad
            :is-general-loading="isLoading"
            :organization-data="organizationData"
          />
        </div>
        <ion-progress-bar
          v-if="isLoading"
          type="indeterminate"
          class="mt-xs"
          color="white"
        ></ion-progress-bar>
      </div>
    </ion-content>
  </ion-page>
</template>
<script setup lang="ts">
  import { IonPage, IonContent, IonImg, IonProgressBar } from '@ionic/vue';
  import arriboLogo from '@/assets/images/arribo-logo.svg';
  import SignUpStepperAbroad from '@/components/onboarding-abroad/SignUpStepperAbroad.vue';
  import { onMounted, ref } from 'vue';
  import { useRelocated } from '@/composables/useRelocated';

  const isLoading = ref(true);
  const organizationData = ref();
  const { handleGetRelocatedGroup } = useRelocated();

  onMounted(async () => {
    isLoading.value = true;
    organizationData.value = await handleGetRelocatedGroup();
    isLoading.value = false;
  });
</script>
<style scoped lang="scss">
  .personalize-wrapper {
    padding-top: 70px;
    &__logo {
      width: 100%;
      display: flex;
      justify-content: center;

      ion-img {
        width: 190px;
      }
    }
  }
</style>
